import axios from "axios";
import { toast } from "react-toastify";
import baseUrl from "../Api";

export async function getNPALoansReport(params) {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };

    return await axios
        .get(`${baseUrl}/npaloansreport?branch=${localStorage.getItem("branch")}&min_unpaid_dues=${params.min_unpaid_dues}${params.member_id ? `&member_id=${params.member_id}` : ''}${params.from_date ? `&from_date=${params.from_date}` : ''}${params.to_date ? `&to_date=${params.to_date}` : ''}`, { headers: header })
        .then((res) => {
            if (res.data.status === true) {
                return res;
            } else {
                toast.error(res.data.message || "Failed to load NPA report");
                return res;
            }
        })
        .catch((err) => {
            toast.error("Error loading NPA report");
            console.log(err);
            return err;
        });
}


